import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhTranslation from '../locales/zh/translation.json';
import zhAbout from '../locales/zh/about.json';
import enTranslation from '../locales/en/translation.json';
import enAbout from '../locales/en/about.json';
import jaTranslation from '../locales/ja/translation.json';
import jaAbout from '../locales/ja/about.json';
import koTranslation from '../locales/ko/translation.json';
import koAbout from '../locales/ko/about.json';
import esTranslation from '../locales/es/translation.json';
import esAbout from '../locales/es/about.json';
import frTranslation from '../locales/fr/translation.json';
import frAbout from '../locales/fr/about.json';

const resources = {
  zh: {
    translation: zhTranslation,
    about: zhAbout,
  },
  en: {
    translation: enTranslation,
    about: enAbout,
  },
  ja: {
    translation: jaTranslation,
    about: jaAbout,
  },
  ko: {
    translation: koTranslation,
    about: koAbout,
  },
  es: {
    translation: esTranslation,
    about: esAbout,
  },
  fr: {
    translation: frTranslation,
    about: frAbout,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: localStorage.getItem('preferred_language') || 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
